document.addEventListener("DOMContentLoaded", function() {

   window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'personalization_storage': 'denied',
  'functionality_storage': 'denied',
  });

  var consent = readCookie('cf-consent-shop');
  if (consent) {
    let decodedString = decodeURIComponent(consent);
    let consentObject = JSON.parse(decodedString);

    if (consentObject) {
      
      window.dataLayer.push({
        "event": "cf_consent_necessary",
        "cf_necessary_enabled": consentObject.necessary,
      });

      window.dataLayer.push({
        "event": "cf_consent_functional",
        "cf_functional_enabled": consentObject.functional,
      });

       window.dataLayer.push({
         "event": "cf_consent_performance",
         "cf_performance_enabled": consentObject.performance,
      });

       window.dataLayer.push({
        "event": "cf_consent_advertising",
        "cf_advertising_enabled": consentObject.advertising,
      });

       window.dataLayer.push({
         "event": "cf_after_consent_update"
      });

      gtag('consent', 'update', {
        'ad_user_data': consentObject.advertising ? 'granted' : 'denied',
        'ad_personalization': consentObject.advertising ? 'granted' : 'denied',
        'ad_storage': consentObject.advertising ? 'granted' : 'denied',
        'analytics_storage': consentObject.performance ? 'granted' : 'denied',
        'personalization_storage': consentObject.functional ? 'granted' : 'denied',
        'functionality_storage': consentObject.functional ? 'granted' : 'denied',
      });

    }
  }
  
});

// reading cookie helper function
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
